import {
  loginFailure,
  loginStart,
  loginSuccess,
  logoutStart,
  logoutSuccess,
  logoutFailure,
  registerStart,
  registerSuccess,
  registerFailure,
} from "./userRedux"
import { serverAPI } from "../services/apiParams"
import Cookies from "universal-cookie"

export const login = async (dispatch, user, setFormErrorMsg) => {
  dispatch(loginStart())
  try {
    const res = await serverAPI.post("api/login", user)
    dispatch(loginSuccess(res.data))
    const cookies = new Cookies()
    cookies.set("auth_token", res.data.jwt)
    setFormErrorMsg(undefined)
  } catch (error) {
    setFormErrorMsg(error.response.data.error)
    dispatch(loginFailure())
  }
}

export const logout = async (dispatch) => {
  dispatch(logoutStart())
  try {
    await serverAPI.post("api/logout")
    dispatch(logoutSuccess())
  } catch (error) {
    dispatch(logoutFailure())
  }
}

export const register = async (
  dispatch,
  user,
  setFormErrorMsg,
  handleClick
) => {
  dispatch(registerStart())
  try {
    await serverAPI.post("api/register", user)
    setFormErrorMsg(undefined)
    dispatch(registerSuccess())
    document.getElementById("registerForm").reset()
    handleClick()
  } catch (error) {
    setFormErrorMsg(error.response.data.errors)
    dispatch(registerFailure())
  }
}
